var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('datatable',{attrs:{"exactSearch":true,"title":_vm.tableTitle,"printable":false,"columns":_vm.columns,"rows":_vm.rows}})],1)}]

export { render, staticRenderFns }